import { matchPath } from 'react-router-dom'
import {
  HomePage,
  StorePage,
  StartPage,
  AcceleratorPage,
  HorseSensePage,
  HorseSenseNovemberPage,
  WaiverPage,
  ClinicsPage,
  PrivateSessionsPage,
  OnlineCoachingPage,
  OnlineCoachingBookedPage,
  OnlineCoachingManagePage,
  TourPage,
  TourBarnsPage,
  TourBarnPage,
  ProgramsPage,
  ConfidentEquestrianPage,
  RidersFoundationGuidePage,
  GroundworkFoundationGuidePage,
  LibertyFoundationsPage,
  ProgramDetailPage,
  SchedulePage,
  AboutPage,
  ContactPage,
  TextUpdatesPage,
  SupportPage,
  WelcomePage,
  AuthConfirmPage,
  AuthActionPage,
  LoginPage,
  AdminPage,
  PortalPage,
  FitnessProgramPage,
  ProgramPlayerPage,
  ChatPage,
  PortalSettingsPage,
  AcceleratorCommunityPage,
  HorseSenseCommunityPage,
  ThankYouPage,
  PrivacyPolicyPage,
  TermsPage,
  RefundPolicyPage,
} from './pages'

// Route pattern → page component, in the same order as the <Route> tree in index.tsx
// (first match wins, matching react-router's own ranking closely enough for
// these paths). main.tsx uses this to load the current route's chunk before
// the first render; see lazyWithRetry.ts for why that matters.
const ROUTE_PAGES: ReadonlyArray<readonly [string, { preload: () => Promise<void> }]> = [
  ['/', HomePage],
  ['/store', StorePage],
  ['/start', StartPage],
  ['/accelerator', AcceleratorPage],
  ['/horse-sense', HorseSensePage],
  ['/horse-sense/november', HorseSenseNovemberPage],
  ['/waiver/:eventId/:attendeeId', WaiverPage],
  ['/masterclass', ClinicsPage],
  ['/private-sessions', PrivateSessionsPage],
  ['/online-coaching', OnlineCoachingPage],
  ['/online-coaching/booked', OnlineCoachingBookedPage],
  ['/online-coaching/manage', OnlineCoachingManagePage],
  ['/tour', TourPage],
  ['/tour/barns', TourBarnsPage],
  ['/tour/barn/:slug', TourBarnPage],
  ['/programs', ProgramsPage],
  ['/programs/confident-equestrian', ConfidentEquestrianPage],
  ['/programs/riders-foundation-guide', RidersFoundationGuidePage],
  ['/programs/groundwork-foundation-guide', GroundworkFoundationGuidePage],
  ['/programs/liberty-foundations', LibertyFoundationsPage],
  ['/programs/:programId', ProgramDetailPage],
  ['/schedule', SchedulePage],
  ['/about', AboutPage],
  ['/contact', ContactPage],
  ['/text-updates', TextUpdatesPage],
  ['/support', SupportPage],
  ['/welcome', WelcomePage],
  ['/auth/confirm', AuthConfirmPage],
  ['/auth/action', AuthActionPage],
  ['/login', LoginPage],
  ['/dashboard', AdminPage],
  ['/portal', PortalPage],
  ['/portal/programs/fitness-for-equestrians', FitnessProgramPage],
  ['/portal/programs/:programId', ProgramPlayerPage],
  ['/portal/chat/:programId', ChatPage],
  ['/portal/settings', PortalSettingsPage],
  ['/portal/community/accelerator', AcceleratorCommunityPage],
  ['/portal/community/horse-sense', HorseSenseCommunityPage],
  ['/thank-you', ThankYouPage],
  ['/privacy-policy', PrivacyPolicyPage],
  ['/terms', TermsPage],
  ['/refund-policy', RefundPolicyPage],
]

export function preloadRoute(pathname: string): Promise<void> {
  const hit = ROUTE_PAGES.find(([pattern]) => matchPath({ path: pattern, end: true }, pathname))
  return hit ? hit[1].preload() : Promise.resolve()
}
